angular.module('ikeweb.spike.sharing').factory('captureSharingService', ['$window', 'captureFactory',

    function($window, captureFactory) {

        var SHARE_CAPTURE_FUNCTION = 'shareCapture',
            IMPORT_SHARED_CAPTURE_FUNCTION = 'importSharedCapture',
            SharedCapture = captureFactory.SharedCapture;

        function makeShareUrl(sharedCapture) {
            return $window.location.origin + '/#/measureView/' + sharedCapture.id;
        }

        function shareCapture(capture, units, zoomArea) {
            return Parse.Cloud.run(SHARE_CAPTURE_FUNCTION, {
                captureid: capture.id,
                units: units,
                zoomArea: zoomArea
            }).then(makeShareUrl);
        }

        function query() {
            return new Parse.Query(SharedCapture);
        }

        function getSharedCapture(id) {
            return query().get(id).then(function(capture) {
                capture.populate();
                return capture;
            });
        }

        function importSharedCapture(sharedCapture) {
            return Parse.Cloud.run(IMPORT_SHARED_CAPTURE_FUNCTION, {
                sharedcaptureid: sharedCapture.id
            });
        }

        return {
            shareCapture: shareCapture,
            getSharedCapture: getSharedCapture,
            importSharedCapture: importSharedCapture
        };
    }
]).config(['$provide',

    function($provide) {

        var functionsToDecorate = [
            'shareCapture',
            'getSharedCapture',
            'importSharedCapture'
        ];

        $provide.decorator('captureSharingService', ['$delegate', 'qPromiseDecoratorService',
            function($delegate, qPromiseDecoratorService) {
                return qPromiseDecoratorService
                    .decorateDelegateWithPromise($delegate, functionsToDecorate);
            }
        ]);

        $provide.decorator('captureSharingService', ['$delegate', 'parseErrorDecoratorService',
            function($delegate, parseErrorDecoratorService) {
                return parseErrorDecoratorService.decorateDelegatePromiseErrors($delegate, functionsToDecorate, {
                    101: 'CAPTURE_NOT_FOUND'
                });
            }
        ]);

        $provide.decorator('captureSharingService', ['$delegate', 'promiseProgressDecoratorService',
            function($delegate, promiseProgressDecoratorService) {
                return promiseProgressDecoratorService
                    .decorateDelegateWithProgress($delegate, functionsToDecorate);
            }
        ]);

        $provide.decorator('captureSharingService', ['$delegate', 'decoratedPromiseBuilder', 'notificationService',
            function($delegate, decoratedPromiseBuilder, notificationService) {

                return decoratedPromiseBuilder
                    .forDelegate($delegate)
                    .decorate('importSharedCapture')
                    .onSuccess(notificationService.success('NOTIFICATION.SHARING.IMPORT_CAPTURE', 'NOTIFICATION.SHARING.IMPORT_COMPLETE'))
                    .onError(notificationService.error('NOTIFICATION.SHARING.IMPORT_CAPTURE', 'NOTIFICATION.SHARING.IMPORT_PROBLEM'))
                    .fork();
            }
        ]);

        $provide.decorator('captureSharingService', ['$delegate', 'loggingDecorator',
            function($delegate, loggingDecorator) {
                return loggingDecorator.decorateDelegateWithLogging($delegate, functionsToDecorate);
            }
        ]);
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/sharing/sharing.service.js
// module id = 590
// module chunks = 0